<script setup lang="ts">
import { useFollowEventMutation } from "~/queries/catalog/eventPreferences";
import type { FollowButtonProps } from "~/types/FollowButton";

type Props = Omit<FollowButtonProps, "type">;

const props = defineProps<Props>();
const { mutateAsync: toggleFollowEvent } = useFollowEventMutation();

const onToggleFollowEvent = () => {
  toggleFollowEvent({
    id: props.id,
    newFollowStatus: !props.isFollowedByUser,
    trackData: {
      followType: "easy",
    },
  });
};
</script>

<template>
  <FollowButton
    :id="id"
    :type="FollowFeatureType.Event"
    :name="name"
    :variant="variant"
    :size="size"
    :is-followed-by-user="isFollowedByUser"
    @click="onToggleFollowEvent"
  />
</template>
